import { axios } from '@/utils/request'

const api = {
  districtPriceDistrict: '/enterprise/districtPrice'
}
// 区域金额列表
export function getDistrictPriceList (parameter) {
  return axios({
    url: api.districtPriceDistrict + '/list',
    method: 'get',
    params: parameter
  })
}

// 删除区域金额
export function delDistrictPrice (parameter) {
  return axios({
    url: api.districtPriceDistrict + '/remove',
    method: 'post',
    params: parameter
  })
}

// 禁用区域金额
export function disableDistrictPrice (parameter) {
  return axios({
    url: api.districtPriceDistrict + '/forbidden',
    method: 'post',
    params: parameter
  })
}

// 启用区域金额
export function enableDistrictPrice (parameter) {
  return axios({
    url: api.districtPriceDistrict + '/enable',
    method: 'post',
    params: parameter
  })
}

export const districtPriceDistrictExport = api.districtPriceDistrict + '/export'
